import React, { PureComponent } from 'react';

import Profile from '../containers/Profile/Profile';
import Page from '../hoc/Page';

class ProfilePage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="pageContainer">
        <Profile />
      </div>
    );
  }
}

export default Page(ProfilePage);
